import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Root from "./pages/admin/Root/Root";
import { Login } from "./pages/admin/Auth/Login";
import { PrivateRoute } from "./misc/private-route";
import { Cabinets } from "./pages/admin/Cabinet/Cabinets";
import { Boards } from "./pages/admin/Board/Boards";
import { Board } from "./pages/admin/Board/Board";
import { Cabinet } from "./pages/admin/Cabinet/Cabinet";
import { Courses } from "./pages/admin/Course/Courses";
import Club from "./pages/admin/Club/Club.tsx";
import Events from "./pages/admin/Events/Events";
import Meetups from "./pages/admin/Meetups/Meetups";
import Disciplinary from "./pages/admin/Disciplinary/Disciplinary";
import MeetupsAdmin from "./components/Meetups/MeetupsAdmin/MeetupsAdmin";
import SocialTranscript from "./components/SocialTransript/SocialTranscript";
import Accesses from "./pages/admin/Accesses/Accesses";
import { checkUserData } from "./actions/user";
import { useEffect } from "react";
import Psychology from './pages/admin/Psychology/Psychology';
import { MeetupsPage } from "./pages/admin/Meetups";
import { ClubPage } from "./pages/admin/Club";
import { Users } from "./pages/admin/Users";
import { FaceRecognition } from "./pages/face-recognition/FaceRecognition";
import { PsychologyMain } from "./pages/admin/Psychology";
import { Exams } from "./pages/admin/Exams";
import { FaceMatch } from "./pages/face-recognition/FaceMatch";
import SchedulePage from "./pages/admin/Schedule";
import { CabinetsNew } from "./pages/admin/Cabinet/Cabinents";
import { Certificates } from "./pages/admin/Certificates";
import { CertificateVerify } from "./pages/certificate-verify/CertificateVerify";
import AttendancePage from "./pages/admin/Attendance";
import AttendanceAdminPage from "./pages/admin/AttendanceAdmin";

function App() {

  useEffect(() => {
    if (window.location.pathname !== '/admin/login') {
      checkUserData()
    }
  }, [])

  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        <Route path="/admin" element={<Root />}>
          <Route
            path={"/admin/cabinets"}
            element={
              <PrivateRoute prefix="admin">
                {/* <Cabinets /> */}
                <CabinetsNew />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/cabinets/:id"}
            element={
              <PrivateRoute prefix="admin">
                <Cabinet />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/boards"}
            element={
              <PrivateRoute prefix="admin">
                <Boards />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/courses"}
            element={
              <PrivateRoute prefix="admin">
                <Courses />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/boards/:id"}
            element={
              <PrivateRoute prefix="admin">
                <Board />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/events/"}
            element={
              <PrivateRoute prefix="admin">
                <Events />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/meetups/"}
            element={
              <PrivateRoute prefix="admin">
                <MeetupsPage />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/meetupsAdmin/"}
            element={
              <PrivateRoute prefix="admin">
                <MeetupsAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/clubs"}
            element={
              <PrivateRoute prefix="admin">
                <ClubPage clubTypeName="club" />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/senate"}
            element={
              <PrivateRoute prefix="admin">
                <ClubPage clubTypeName="senate" />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/disciplinary"}
            element={
              <PrivateRoute prefix="admin">
                <Disciplinary />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/users"}
            element={
              <PrivateRoute prefix="admin">
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/social-transcripts"}
            element={
              <PrivateRoute prefix="admin">
                <SocialTranscript />
              </PrivateRoute>
            }
          />
          <Route
            path={"/admin/accesses"}
            element={
              <PrivateRoute prefix="admin">
                <Accesses />
              </PrivateRoute>
            }
          />
          <Route
            path={'/admin/psychology'}
            element={
              <PrivateRoute prefix="admin">
                <PsychologyMain />
              </PrivateRoute>
            }
          />
          <Route
            path={'/admin/exams'}
            element={
              <PrivateRoute prefix="admin">
                <Exams />
              </PrivateRoute>
            }
          />

          <Route
            path={"/admin/cabinets/schedule"}
            element={
              <PrivateRoute prefix="admin">
                <SchedulePage />
              </PrivateRoute>
            }
          />

          <Route
            path={'/admin/certificates'}
            element={
              <PrivateRoute prefix="admin">
                <Certificates />
              </PrivateRoute>
            }
          />
          <Route
            path={'/admin/attendance'}
            element={
              <PrivateRoute prefix="admin">
                <AttendancePage />
              </PrivateRoute>
            }
          />
          <Route
            path={'/admin/attendance/admin'}
            element={
              <PrivateRoute prefix="admin">
                <AttendanceAdminPage />
              </PrivateRoute>
            }
          />
        </Route>
        <Route path={"/admin/login"} element={<Login />} />
        <Route path={"/face-verify"} element={<FaceRecognition />} />
        <Route path={"/face-match"} element={<FaceMatch />} />
        <Route path={"/certificate-verify/:code"} element={<CertificateVerify />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
